(() => {
  function initKeen() {
    const main = document.querySelector(".js-keen-main");
    const thumbs = document.querySelector(".js-keen-thumbs");
    if (!main || !thumbs || !window.KeenSlider) return;

    const mainSlider = new KeenSlider(main, { slides: { perView: 1 } });
    const thumbSlider = new KeenSlider(thumbs, { slides: { perView: "auto", spacing: 10 } });

    const thumbEls = [...thumbs.querySelectorAll(".keen-thumb")];

    function setActive(i) {
      thumbEls.forEach((el, idx) => el.classList.toggle("is-active", idx === i));
      thumbSlider.moveToIdx(i);
    }

    setActive(0);

    mainSlider.on("slideChanged", (s) => setActive(s.track.details.rel));
    thumbEls.forEach((el, i) => el.addEventListener("click", () => mainSlider.moveToIdx(i)));
  }

  document.addEventListener("DOMContentLoaded", initKeen);
})();
